import React from 'react';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';
import { GeneralPageLayout } from '../layout/GeneralPageLayout';
import { StatsDiv } from '../component/stats/StatsDiv';

export const StatsPage = () => (
  <GeneralPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<StatsDiv />}
  />
);
